export default "__VITE_ASSET__DqHUwsZZ__"